// The one way to call salvagers-api (api/). Every route but health is behind
// the shared Cognito authorizer, so every call carries the session's token;
// refusals come back as {"detail": "..."}. The mechanics are kast-common's
// api-client; this is its wording.

import { createApiClient, jsonBody } from "@jkast90/kast-common/api-client";
import { session } from "./auth/session";
import { getDeploymentConfig } from "./deployment-config";

export { ApiError, SignedOutError, errorText, statusOf } from "@jkast90/kast-common/api-client";

export const REQUEST_TIMEOUT_MS = 8_000;

const client = createApiClient({
  baseUrl: () => getDeploymentConfig().apiUrl,
  session,
  timeoutMs: REQUEST_TIMEOUT_MS,
});

export const apiRequest = client.request;
export const apiJson = client.json;

/** A route with no authorizer (health, the banner, sign-ups): no token, no refresh. */
export const publicRequest = client.publicRequest;
export const publicJson = client.publicJson;

export const json = jsonBody;
